import Vue from 'vue';
import Router from 'vue-router';

import store from './store/index';

import IndexPage from './views/welcome/IndexPage.vue';
import WelcomePage from './views/welcome/WelcomePage.vue';
import LoginPage from './views/welcome/LoginPage.vue';
import PasswordRecoveryPage from './views/welcome/PasswordRecoveryPage.vue';
import RegisterPage from './views/welcome/RegisterPage.vue';

import MapPage from './views/map/MapPage.vue';
import MapOverview from './views/map/MapOverview.vue';
import MapDetail from './views/map/MapDetail.vue';
import MapDetailHistory from './views/map/MapDetailHistory.vue';

import DeviceEditDetails from './views/device/DeviceEditDetails.vue';
import DeviceActivation from './views/device/activate/DeviceActivation.vue';

import AccountPage from './views/account/AccountPage.vue';
import HelpPage from './views/account/HelpPage.vue';
import BlePage from './views/ble/BlePage';
import BleDetailPage from './views/ble/BleDetailPage';
import RegisterNamePage from './views/welcome/RegisterNamePage';
import DeviceOverview from './views/device/DeviceOverview';
import DeviceAdd from './views/device/register/DeviceAdd';
import DeviceRegistration from './views/device/register/DeviceRegistration';
import DeviceSubscribe from './views/device/register/DeviceSubscribe';

import NotificationListPage from './views/notifications/NotificationListPage';
import NotificationDetailsPage from './views/notifications/NotificationDetailsPage';
import DeviceSubscription from './views/device/register/DeviceSubscription';
import DeviceLink from './views/device/activate/DeviceLink';
import DeviceLinkSuccess from './views/device/activate/DeviceLinkSuccess';
import DeviceWifi from './views/device/activate/DeviceWifi';
import DeviceWifiSuccess from './views/device/activate/DeviceWifiSuccess';
import DeviceUpdateCode from './views/device/activate/DeviceUpdateCode';
import DeviceAdvanced from './views/device/DeviceAdvanced';
import DeviceConnect from './views/device/activate/DeviceConnect';
import DeviceActivationPin from './views/device/activate/DeviceActivationPin';

import SubscriptionRenewalPage from './views/subscription/SubscriptionRenewalPage';
import SubscriptionRenewalSuccess from './views/subscription/SubscriptionRenewalSuccess';

Vue.use(Router);

const router = new Router({
	mode: process.env.CORDOVA_PLATFORM === 'browser' ? 'history' : 'hash',
	routes: [
		{
			path: '/',
			component: IndexPage,
			children: [
				{
					path: '/',
					name: 'welcome',
					component: WelcomePage,
				}, {
					path: '/login',
					name: 'login',
					component: LoginPage,
					meta: { title: 'Login' },
				}, {
					path: '/password-recovery',
					name: 'password-recovery',
					component: PasswordRecoveryPage,
					meta: { title: 'Wachtwoord vergeten' },
				}, {
					path: '/register',
					name: 'register',
					component: RegisterPage,
					meta: { title: 'Registreren' },
				}, {
					path: '/register/name',
					name: 'register-name',
					component: RegisterNamePage,
					meta: { title: 'Registreren' },
				}
			],
		}, {
			path: '/e-finders',
			name: 'devices',
			component: MapPage,
			children: [
				{
					path: '/',
					name: 'devices.index',
					component: MapOverview,
					meta: { title: 'Mijn E-finders', requiresLogin: true },
				}, {
					path: 'list',
					name: 'devices.list',
					component: DeviceOverview,
					meta: { title: 'Mijn E-finders', requiresLogin: true },
				}, {
					path: ':id',
					name: 'devices.show',
					component: MapDetail,
					meta: { title: 'E-finder', requiresLogin: true },
				}, {
					path: ':id/history',
					name: 'devices.show.history',
					component: MapDetailHistory,
					meta: { title: 'E-finder History', requiresLogin: true },
				}, {
					path: ':id/edit',
					name: 'devices.edit',
					component: DeviceEditDetails,
					meta: { title: 'E-finder Bewerken', requiresLogin: true },
				}, {
					path: ':id/advanced',
					name: 'devices.advanced',
					component: DeviceAdvanced,
					meta: { title: 'E-finder Geavanceerd', requiresLogin: true },
				}, {
					path: ':id/ble',
					name: 'devices.ble',
					component: BleDetailPage,
					meta: { title: 'E-finder Ble', requiresLogin: true },
				}, {
					path: 'add',
					name: 'devices.add',
					component: DeviceAdd,
					meta: { title: 'E-finder registreren', requiresLogin: true },
				}, {
					path: 'register',
					name: 'devices.register',
					component: DeviceRegistration,
					meta: { title: 'E-finder toevoegen', requiresLogin: true },
				}, {
					path: 'register/:slug',
					name: 'devices.subscription',
					component: DeviceSubscription,
					meta: { title: 'E-finder registreren', requiresLogin: true },
				}, {
					path: 'register/:slug/:productId',
					name: 'devices.subscribe',
					component: DeviceSubscribe,
					meta: { title: 'E-finder registreren', requiresLogin: true },
				}, {
					path: ':id/activate/pin',
					name: 'devices.activate.pin',
					component: DeviceActivationPin,
					meta: { title: 'E-finder koppelen', requiresLogin: true },
				}, {
					path: ':id/activate',
					name: 'devices.activate',
					component: DeviceActivation,
					meta: { title: 'E-finder koppelen', requiresLogin: true },
				}, {
					path: ':id/activate/code',
					name: 'devices.activate.code',
					component: DeviceUpdateCode,
					meta: { title: 'E-finder koppelen', requiresLogin: true },
				}, {
					path: ':id/activate/connect',
					name: 'devices.activate.connect',
					component: DeviceConnect,
					meta: { title: 'E-finder verbinden', requiresLogin: true },
				}, {
					path: ':id/activate/link',
					name: 'devices.activate.link',
					component: DeviceLink,
					meta: { title: 'E-finder koppelen', requiresLogin: true },
				}, {
					path: ':id/activate/link-success',
					name: 'devices.activate.link-success',
					component: DeviceLinkSuccess,
					meta: { title: 'E-finder koppelen', requiresLogin: true },
				}, {
					path: ':id/activate/wifi',
					name: 'devices.activate.wifi',
					component: DeviceWifi,
					meta: { title: 'E-finder koppelen', requiresLogin: true },
				}, {
					path: ':id/activate/wifi-success',
					name: 'devices.activate.wifi-success',
					component: DeviceWifiSuccess,
					meta: { title: 'E-finder koppelen', requiresLogin: true },
				},
			],
		}, {
			path: '/account',
			component: AccountPage,
			meta: { title: 'Mijn Account', requiresLogin: true },
		}, {
			path: '/help',
			component: HelpPage,
			meta: { title: 'Help', requiresLogin: true },
		}, {
			path: '/ble',
			component: BlePage,
			meta: { title: 'Ble', requiresLogin: true },
		}, {
			path: '/ble/:id',
			component: BleDetailPage,
			meta: { title: 'BleDetail', requiresLogin: true },
		}, {
			path: '/notifications',
			component: NotificationListPage,
			meta: { title: 'Notifications', requiresLogin: true },
		},{
			path: '/notifications/:id',
			component: NotificationDetailsPage,
			meta: { title: 'Notification', requiresLogin: true },
		}, {
			path: '/subscription-renewal',
			name: 'subscription.renewal',
			component: SubscriptionRenewalPage,
			meta: {title: 'Abonnement Verlengen'},
		}, {
			path: '/subscription-renewal/success',
			name: 'subscription.renewal.success',
			component: SubscriptionRenewalSuccess,
			meta: {title: 'Abonnement Verlengd'},
		},

		// {
		//   path: '/about',
		//   name: 'about',
		//   // route level code-splitting
		//   // this generates a separate chunk (about.[hash].js) for this route
		//   // which is lazy-loaded when the route is visited.
		//   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
		// },
	],
});

function getToken(){
	return new Promise((resolve, reject) => {
		document.addEventListener('deviceready', () => {
			if(typeof NativeStorage !== 'undefined') {
				console.log('NativeStorage getItem token');
				NativeStorage.getItem('token', (token) => resolve(token), () => resolve(null));
			}else{
				return resolve(localStorage.token);
			}
		});
	});
}

router.beforeEach(async (to, from, next) => {
	const token = await getToken();

	document.title = to.meta.title ? `${to.meta.title} - E-finder` : 'E-finder';

	if (!token && (!to.meta.requiresLogin || store.getters.isLoggedIn)) return next();
	if (token && store.getters.isLoggedIn) return next();

	store.dispatch('logInByToken')
		.then(() => (to.fullPath === '/' ? next('/e-finders') : next()))
		.catch(() => next('/'));
});

export default router;
